module.exports = __webpack_public_path__ + "img/Frame-39.20c3d4df.svg";